import z from "zod";
import { AI_TOOL, INTERACTION_TYPE } from "./ai.schema";


export const Skill = z.object({
  label: z.string().optional(),
  type: z.enum(INTERACTION_TYPE),
  description: z.string().optional(),
  skill_id: z.string(),
  fileInputRequired: z.boolean().optional(),
  modelFileUploadOnStart: z.boolean().optional(),
  containerOnly: z.boolean().optional(),
  singleFileUpload: z.boolean().optional(),
  firstMessageTool: z.union([
    z.literal(AI_TOOL.WEB_SEARCH),
    z.literal(AI_TOOL.GET_DATASET_META)]
  ).optional(),
  firstMessage: z.string().optional(),
  model: z.string(),
  jsonSchema: z.string().optional(),
  inTesting: z.boolean().optional(),
});

export type Skill = z.infer<typeof Skill>;

export interface SkillFilter {
  type?: INTERACTION_TYPE
}
